import { lazy } from 'react';

// ** Document title
const TemplateTitle = 'VALJOB';

// ** Default Route
const ClientDefaultRoute = '/tableau-bord-agence';

//** route Restriction
const RestrictionDefaultRoute = '/creer-une-annonce';

const RestrictionClientRoutes = [
  {
    path:'/planification',
    component: lazy(() => import('@views/planning'))
  },
  {
    path: '/creer-une-annonce',
    component: lazy(() => import('@views/agency/createAd'))
  },
  {
    path:'/mes-commandes',
    component: lazy(() => import('@views/agency/orders'))
  },
  {
    path: '/login',
    component: lazy(() => import('@views/authentification/login')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/releves-heures',
    component: lazy(() => import('@views/timeSheet/TimeSheet'))
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('@views/authentification/ForgotPassword')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/reset-password/:token',
    component: lazy(() => import('@views/authentification/ResetPassword')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/register/agency',
    component: lazy(() => import('@views/authentification/register/RegisterAgency')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/support',
    className: 'email-application',
    component: lazy(() => import('@views/parameters/support'))
  },
  {
    path: '/parametres',
    component: lazy(() => import('@views/parameters/security'))
  },
  {
    path: '/communication',
    component: lazy(() => import('@views/parameters/communicate'))
  },
  {
    path: '/apply/annonce/:id/:source',
    component: lazy(() => import('@views/share')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/direct/annonce/:id/:source',
    component: lazy(() => import('@views/share')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/annonce/:id/:source',
    component: lazy(() => import('@views/share')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/tableau-bord-agence',
    component: lazy(() => import('@views/dashbord/agency/DashboardAgency'))
  },
  { 
    path: '/cv-theque',
    className: 'email-application',
    component: lazy(() => import('@views/agency/cvTech'))
  },
  {
    path:'/mes-annonces',
    component: lazy(() => import('@views/agency/ads'))
  },
];

// ** Merge Routes
const ClientRoutes = [ 
  {
    path:'/planification',
    component: lazy(() => import('@views/planning'))
  },
  {
    path:'/partners/export/:s/:typeFile',
    component: lazy(() => import('@views/export')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path:'/mes-dossiers',
    component: lazy(() => import('@views/agency/myFolders'))
  },
  {
    path:'/mes-commandes',
    component: lazy(() => import('@views/agency/orders'))
  },

  {
    path: '/candidatures',
    component: lazy(() => import('@views/agency/applications'))
  },
  {
    path: '/creer-une-annonce',
    component: lazy(() => import('@views/agency/createAd'))
  },
  {
    path: '/login',
    component: lazy(() => import('@views/authentification/login')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path:'/activites-generales',
    component: lazy(() => import('@views/agency/activity'))
  },
  {
    path: '/notifications',
    component: lazy(() => import('@views/notifications/Notifications'))
  },
  {
    path: '/releves-heures',
    component: lazy(() => import('@views/timeSheet/TimeSheet'))
  },
  {
    path: '/documents',
    component: lazy(() => import('@views/docsAgency'))
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('@views/authentification/ForgotPassword')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/reset-password/:token',
    component: lazy(() => import('@views/authentification/ResetPassword')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/register/agency',
    component: lazy(() => import('@views/authentification/register/RegisterAgency')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/support',
    className: 'email-application',
    component: lazy(() => import('@views/parameters/support'))
  },
  {
    path: '/parametres',
    component: lazy(() => import('@views/parameters/security'))
  },
  {
    path: '/communication',
    component: lazy(() => import('@views/parameters/communicate'))
  },
  {
    path: '/apply/annonce/:id/:source',
    component: lazy(() => import('@views/share')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/direct/annonce/:id/:source',
    component: lazy(() => import('@views/share')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/annonce/:id/:source',
    component: lazy(() => import('@views/share')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  }
];

export { RestrictionClientRoutes, RestrictionDefaultRoute, ClientDefaultRoute, TemplateTitle, ClientRoutes };
